export enum Integration {
  GET_INTEGRATION_REQUEST = '@integration/GET_INTEGRATION_REQUEST',
  GET_INTEGRATION_SUCCESS = '@integration/GET_INTEGRATION_SUCCESS',
  GET_INTEGRATION_FAIL = '@integration/GET_INTEGRATION_FAIL',
}
